import React, { Fragment, useState } from 'react'
import estilos from './ZonasComponent.module.css'

function VerInfoDelAsociadoComponent(props) {

        const asociado = props.asociado.anexocliente.cliente

        console.log(asociado)

        return (
                <div>
                        <h5>Información del Asociado:<br /><br />
                        </h5>
                        <div className="row">
                                <div className="col">
                                        <hr></hr>
                                        <h5>Razon Social: {asociado.nombrerazonsocial}</h5>
                                        <h5>Numero de Socio: {asociado.numerosocio}</h5>
                                        <h5>RFC: {asociado.rfc}</h5>
                                        <h5>Telefono: {asociado.telefono}</h5>
                                        <h5>Correo Electronico: {asociado.correoelectronico}</h5>
                                        <h5>Representante Legal: {asociado.nombrerepresentantelegal}</h5>
                                        <h5>Telefono Representante: {asociado.telefonorepresentante}</h5>
                                        <h5>Correo Electronico Representante: {asociado.correoelectronicorepresentante}</h5>
                                        <hr></hr>
                                </div>
                        </div>
                        <button onClick={() => props.handleCloseModalVerInfoDelAsociado()} className='btn btn-success'>Aceptar</button>
                </div>
        )
}

export default VerInfoDelAsociadoComponent